import PropTypes from "prop-types"
import Icon from "components/planning_center_icon"
import { Spinner } from "@planningcenter/tapestry-react"
import { css } from "@emotion/core"
import { colors } from "components/shared/admin_colors"

const styles = {
  message: css`
    align-items: center;
    display: flex;
    color: ${colors.neutral_700};
    font-size: 13px;
    gap: 4px;
    margin-left: 2px;
    white-space: nowrap;
  `,
  success: css`
    color: ${colors.success};
  `,
  error: css`
    color: ${colors.error};
  `
}

const StatusMessage = ({ icon, text, type, style }) => {
  return (
    <div className="d-ib ml-1">
      <div css={[style, styles.message, type && styles[type]]}>
        {icon === "spinner" ? (
          <Spinner size="xs" thickness={1.5} />
        ) : (
          icon && <Icon symbol={icon} className="p-r t-2p" />
        )}
        {text && <span>{text}</span>}
      </div>
    </div>
  )
}

StatusMessage.propTypes = {
  text: PropTypes.string,
  icon: PropTypes.string,
  type: PropTypes.oneOf(["success", "error", "saving", "pending"]),
  style: PropTypes.shape({})
}

export default StatusMessage
